<template>
  <div class="spond-groups">
    <nav class="navbar navbar-expand-lg navbar-light border-bottom shadow-sm bg-light mb-3">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="back-icon bi bi-arrow-left-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
          </svg>
          <span>{{$t('spondGroups.header')}}</span>
        </router-link>    
        <a class="small link-button" v-on:click="signout()">{{$t('spondGroups.logOut')}}</a>
      </div>
    </nav>
    <div class="container">
      <div v-if="!groupsLoaded" class="text-center mt-4">        
        <div class="spinner-border mt-4" style="width: 3rem; height: 3rem;" role="status"></div>
        <div class="text-muted mt-4">{{$t('spondGroups.loading')}}</div>
      </div>
      <section class="py-5 text-center container" v-if="groupsLoaded && groups && groups.length == 0">
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
            <h1 class="font-weight-light">{{$t('spondGroups.noGroupsFound')}}</h1>
            
            <p class="lead text-muted">
              {{$t('spondGroups.noGroupsFoundDescription')}}              
            </p>
          </div>
        </div>       
      </section>
      <div v-if="groupsLoaded && groups && groups.length > 0">
        <p class="text-muted mb-4 mt-4 pt-2">
          {{$t('spondGroups.multipleGroups')}}          
        </p>
        <div v-for="group in groups" :key="group.id">
          <div class="card mb-3 shadow-sm" v-on:click="selectGroup(group)">     
            <div class="card-body">       
              <div class="d-flex justify-content-between">                
                <span class="text-gray-dark">                  
                  <span>
                    {{ group.name }}
                  </span>
                </span>
                <a class="card-link link-button" v-on:click="selectGroup(group)">{{$t('spondGroups.select')}}</a>
              </div> 
            </div> 
          </div>          
        </div>
      </div>
    </div>    
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, del, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { SpondGroup } from "../models/Models";
import { SpondService } from '../services/SpondService';
import { inject } from 'vue';
import router from '../router';

export default class SpondGroups extends Vue {
  public groups: Array<SpondGroup> = [];
  public groupsLoaded = false;  
  private spondService: SpondService;

  async created() {
    this.spondService = inject('SpondService', new SpondService());
    
    this.spondService.getGroups()
      .then(async groups => {

        if (groups.length === 1) {
          await this.selectGroup(groups[0]);
          return;
        }

        this.groups = groups;
        this.groupsLoaded = true;
      })
      .catch(async err => {
        router.push({ name: "SpondLogin" });  
      });
  }

  async selectGroup(group: SpondGroup) {
    this.spondService.setSelectedGroup(group);

    router.push({ name: "SpondMatches" });    
  }

  async signout() {
    await this.spondService.signout();
    
    router.push({ name: "Matches" });  
  }
}
</script>
